import { NewOrganizationPayload } from "@API/Organizations/types";
import { createAction } from "@reduxjs/toolkit";
import { IOrganization, OrganizationId, OrganizationModalType } from "./types";

export const organizationsListRequest = createAction<void>(
  "ORGANIZATIONS_LIST/REQUEST"
);
export const organizationsListSuccess = createAction<IOrganization[]>(
  "ORGANIZATIONS_LIST/SUCCESS"
);
export const organizationsListFail = createAction<Error>(
  "ORGANIZATIONS_LIST/FAIL"
);

export const updateOrganizationRequest = createAction<IOrganization>(
  "UPDATE_ORGANIZATION/REQUEST"
);
export const updateOrganizationSuccess = createAction<IOrganization>(
  "UPDATE_ORGANIZATION/SUCCESS"
);
export const updateOrganizationFail = createAction<Error>(
  "UPDATE_ORGANIZATION/FAIL"
);

export const updateSelectedOrganizationId = createAction<OrganizationId>(
  "UPDATE_SELECTED_ORGANIZATION_ID"
);

// system user requests
export const createOrganizationRequest = createAction<NewOrganizationPayload>(
  "CREATE_ORGANIZATION/REQUEST"
);
export const createOrganizationSuccess = createAction<IOrganization>(
  "CREATE_ORGANIZATION/SUCCESS"
);
export const createOrganizationFail = createAction<Error>(
  "CREATE_ORGANIZATION/FAIL"
);

export const setModalCreateOrganization = createAction<void>(
  "SET_MODAL_CREATE_ORGANIZATION"
);
export const setModalCreateOrganizationType =
  createAction<OrganizationModalType>("SET_MODAL_CREATE_ORGANIZATION_TYPE");
export const resetCreateOrganizationModal = createAction<void>(
  "MODAL_CREATE_ORGANIZATION_RESET"
);

export const systemUpdateOrganizationRequest = createAction<IOrganization>(
  "SYSTEM_UPDATE_ORGANIZATION/REQUEST"
);
export const systemUpdateOrganizationSuccess = createAction<IOrganization>(
  "SYSTEM_UPDATE_ORGANIZATION/SUCCESS"
);
export const systemUpdateOrganizationFail = createAction<Error>(
  "SYSTEM_UPDATE_ORGANIZATION/FAIL"
);

export const deleteOrganizationRequest = createAction<OrganizationId>(
  "DELETE_ORGANIZATION/REQUEST"
);
export const deleteOrganizationSuccess = createAction<OrganizationId>(
  "DELETE_ORGANIZATION/SUCCESS"
);
export const deleteOrganizationFail = createAction<Error>(
  "DELETE_ORGANIZATION/FAIL"
);
